enum LabelVisibility {
  Admin = 'Admin',
  Public = 'Public'
}
export default LabelVisibility
